/**
 * Typed Redux Hooks
 * 
 * Purpose: Type-safe hooks for Redux
 * Replaces useDispatch and useSelector with typed versions
 */

import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux'
import type { RootState, AppDispatch } from './store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

